/* ==========================================================================
   HUMO BARRILES · PREVENTA · PASOS DESPLEGABLES
   assets/preorder-pasos.js

   Paso 1 barril, paso 2 accesorios, paso 3 carrito.
   Al agregar un barril se cierra el paso 1 y se abre el 2.
   CONTINUAR A MI PREVENTA cierra el paso 2 y lleva al carrito.
   No toca el carrito: solo lo lee para saber en qué paso va el cliente.
   ========================================================================== */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-escena]');
  if (!raiz) return;
  var p1 = raiz.querySelector('[data-paso="1"]');
  var p2 = raiz.querySelector('[data-paso="2"]');
  if (!p1 || !p2) return;

  var LENTO = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CARRITO = raiz.dataset.cartUrl || '/cart';

  var TX = {
    es: {
      barril: function (n) { return n === 1 ? '1 barril en tu preventa' : n + ' barriles en tu preventa'; },
      acc: function (n) { return n === 0 ? 'Sin accesorios todavía' : (n === 1 ? '1 accesorio agregado' : n + ' accesorios agregados'); },
      sinBarril: 'Aún no eliges tu barril',
      primero: 'Primero elige tu barril'
    },
    en: {
      barril: function (n) { return n === 1 ? '1 barrel in your pre-order' : n + ' barrels in your pre-order'; },
      acc: function (n) { return n === 0 ? 'No accessories yet' : (n === 1 ? '1 accessory added' : n + ' accessories added'); },
      sinBarril: 'No barrel picked yet',
      primero: 'Pick your barrel first'
    }
  };
  function idioma() { return window.HUMO_IDIOMA ? window.HUMO_IDIOMA.get() : 'es'; }
  function T() { return TX[idioma()]; }
  function movil() { return window.innerWidth <= 767; }

  var BARRILES = [];
  try {
    var b = raiz.querySelector('[data-preorder-barrel-ids]');
    if (b) BARRILES = JSON.parse(b.textContent) || [];
  } catch (e) { BARRILES = []; }

  /* ---------- abrir y cerrar ---------- */
  function poner(p, abierto) {
    if (p.classList.contains('is-abierto') === abierto) return;
    p.classList.add('is-animando');
    p.classList.toggle('is-abierto', abierto);
    var barra = p.querySelector('[data-paso-barra]');
    if (barra) barra.setAttribute('aria-expanded', String(abierto));
    setTimeout(function () { p.classList.remove('is-animando'); }, LENTO ? 0 : 560);
  }

  function bajarA(el) {
    setTimeout(function () {
      var y = el.getBoundingClientRect().top + window.pageYOffset - (movil() ? 14 : 24);
      window.scrollTo({ top: y, behavior: LENTO ? 'auto' : 'smooth' });
    }, LENTO ? 0 : 380);
  }

  /* ---------- lectura del carrito ---------- */
  var estado = { barriles: 0, accesorios: 0 };
  var primeraLectura = true;
  var esperaBarril = false;

  function contar(c) {
    var nb = 0, na = 0;
    (c.items || []).forEach(function (it) {
      if (!it || it.quantity <= 0) return;
      if (BARRILES.indexOf(it.variant_id || it.id) !== -1) nb += it.quantity;
      else na += it.quantity;
    });
    estado.barriles = nb;
    estado.accesorios = na;
  }

  function resumenes() {
    var r1 = p1.querySelector('[data-paso-resumen]');
    var r2 = p2.querySelector('[data-paso-resumen]');
    if (r1) r1.textContent = estado.barriles ? T().barril(estado.barriles) : T().sinBarril;
    if (r2) r2.textContent = estado.barriles ? T().acc(estado.accesorios) : T().primero;
    p1.classList.toggle('is-hecho', estado.barriles > 0);
    p2.classList.toggle('is-hecho', estado.accesorios > 0);
  }

  function leer() {
    return fetch(CARRITO + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        contar(c);
        resumenes();

        if (primeraLectura) {
          primeraLectura = false;
          /* quien vuelve con un barril en el carrito arranca en los accesorios */
          if (estado.barriles) { poner(p1, false); poner(p2, true); }
          return;
        }

        if (esperaBarril && estado.barriles) {
          esperaBarril = false;
          poner(p1, false);
          poner(p2, true);
          bajarA(p2);
        }
      })
      .catch(function () {});
  }

  var espera = null;
  document.addEventListener('humo:carrito-cambio', function () {
    clearTimeout(espera);
    espera = setTimeout(leer, 120);
  });

  /* ---------- clics ---------- */
  raiz.addEventListener('click', function (ev) {
    var t = ev.target;

    var barra = t.closest('[data-paso-barra]');
    if (barra) {
      var p = barra.closest('[data-paso]');
      var abrir = !p.classList.contains('is-abierto');
      poner(p, abrir);
      if (abrir) bajarA(p);
      return;
    }

    if (t.closest('[data-add-barril]')) { esperaBarril = true; return; }

    if (t.closest('[data-ir-accesorios]')) { poner(p2, true); return; }

    if (t.closest('[data-paso-seguir]')) {
      poner(p2, false);
      if (movil()) {
        var abrirCarro = raiz.querySelector('[data-bm-abrir]');
        if (abrirCarro) setTimeout(function () { abrirCarro.click(); }, LENTO ? 0 : 300);
      } else {
        var carro = raiz.querySelector('.hb-esc__carro');
        if (carro) {
          bajarA(carro);
          carro.classList.add('is-llamado');
          setTimeout(function () { carro.classList.remove('is-llamado'); }, 1800);
        }
      }
    }
  }, true);

  document.addEventListener('humo:idioma', resumenes);


  /* ======================================================================
     URGENCIA: la preventa cierra en una fecha fija, igual para todos.
     El contador nunca se reinicia. Al llegar la fecha cambia a "terminó".
     ====================================================================== */
  var tarjeta = null;
  var CIERRE = Date.parse(raiz.getAttribute('data-cierre') || '2026-10-22T23:59:00-04:00');
  var TU = {
    es: { tit: 'PRECIOS SOLO POR PREVENTA · TERMINA EN', fin: 'LA PREVENTA TERMINÓ', d: 'D', h: 'H', m: 'M', s: 'S',
          carro: function (t) { return 'Tu precio de preventa termina en ' + t; },
          despues: 'Valor del equipo completo: el barril más los accesorios incluidos, a su precio de venta por separado.' },
    en: { tit: 'PRE-SALE PRICES ONLY · ENDS IN', fin: 'THE PRE-SALE HAS ENDED', d: 'D', h: 'H', m: 'M', s: 'S',
          carro: function (t) { return 'Your pre-sale price ends in ' + t; },
          despues: 'Full kit value: the barrel plus the included accessories, at their individual selling prices.' }
  };
  function U() { return TU[idioma()]; }
  function dos(n) { return n < 10 ? '0' + n : '' + n; }

  var franja = document.createElement('div');
  franja.className = 'hb-urg';
  franja.setAttribute('role', 'timer');
  franja.innerHTML =
    '<span class="hb-urg__txt" data-u-txt></span>' +
    '<span class="hb-urg__reloj">' +
      '<b data-u="d">00</b><i data-u-l="d"></i>' +
      '<b data-u="h">00</b><i data-u-l="h"></i>' +
      '<b data-u="m">00</b><i data-u-l="m"></i>' +
      '<b data-u="s">00</b><i data-u-l="s"></i>' +
    '</span>';
  var rejilla = raiz.querySelector('.hb-esc__rejilla');
  if (rejilla) raiz.insertBefore(franja, rejilla);

  var enCarro = document.createElement('p');
  enCarro.className = 'hb-urg-carro';
  var pagar = raiz.querySelector('[data-checkout]');
  if (pagar && pagar.parentNode) pagar.parentNode.insertBefore(enCarro, pagar);

  var despues = document.createElement('p');
  despues.className = 'hb-esc__despues';
  var precios = raiz.querySelector('.hb-esc__precios');
  if (precios && precios.parentNode) precios.parentNode.insertBefore(despues, precios.nextSibling);

  function textosUrgencia() {
    raiz.setAttribute('data-lang', idioma());
    franja.querySelector('[data-u-txt]').textContent = U().tit;
    ['d', 'h', 'm', 's'].forEach(function (k) { franja.querySelector('[data-u-l="' + k + '"]').textContent = U()[k]; });
    despues.textContent = U().despues;
    reloj();
  }

  function reloj() {
    var r = CIERRE - Date.now();
    if (!CIERRE || r <= 0) {
      franja.classList.add('is-fin');
      franja.querySelector('[data-u-txt]').textContent = U().fin;
      enCarro.hidden = true;
      if (tarjeta) tarjeta.classList.add('fin-preventa');
      return false;
    }
    var t = Math.floor(r / 1000);
    var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
    franja.querySelector('[data-u="d"]').textContent = dos(d);
    franja.querySelector('[data-u="h"]').textContent = dos(h);
    franja.querySelector('[data-u="m"]').textContent = dos(m);
    franja.querySelector('[data-u="s"]').textContent = dos(s);
    if (tarjeta) {
      tarjeta.querySelector('[data-pr="d"]').textContent = dos(d);
      tarjeta.querySelector('[data-pr="h"]').textContent = dos(h);
      tarjeta.querySelector('[data-pr="m"]').textContent = dos(m);
      tarjeta.querySelector('[data-pr="s"]').textContent = dos(s);
    }
    enCarro.hidden = false;
    enCarro.textContent = U().carro(d + 'd ' + dos(h) + 'h ' + dos(m) + 'm');
    return true;
  }

  textosUrgencia();
  var pulso = setInterval(function () { if (!reloj()) clearInterval(pulso); }, 1000);
  document.addEventListener('humo:idioma', textosUrgencia);


  /* ======================================================================
     BLOQUE DE PRECIO: valor del equipo, precio después de la preventa,
     precio de preventa y ahorro real. Usa los mismos elementos que
     actualiza el selector de barril, así que se recalcula solo.
     ====================================================================== */
  var TP = {
    es: { cab1: 'PRECIO ESPECIAL DE', cab2: 'PREVENTA', equipo: 'VALOR DEL EQUIPO COMPLETO', reg: 'PRECIO DESPUÉS DE LA PREVENTA', pre: 'CÓMPRALO HOY POR SOLO', ahorra: 'AHORRA', ahora: 'COMPRANDO AHORA', off: 'OFF', termina: 'ESTE PRECIO TERMINA EN', d: 'DÍAS', h: 'HRS', m: 'MIN', s: 'SEG' },
    en: { cab1: 'SPECIAL', cab2: 'PRE-SALE PRICE', equipo: 'FULL KIT VALUE', reg: 'PRICE AFTER PRE-SALE', pre: 'GET IT TODAY FOR ONLY', ahorra: 'SAVE', ahora: 'BUYING NOW', off: 'OFF', termina: 'THIS PRICE ENDS IN', d: 'DAYS', h: 'HRS', m: 'MIN', s: 'SEC' }
  };
  var MEGAFONO = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4 13v6a2 2 0 0 0 2 2h2l2 6h4l-2-6h1l11 5V6L13 11H6a2 2 0 0 0-2 2z" fill="currentColor"/><path d="M28 12.5a4 4 0 0 1 0 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var precioEl = raiz.querySelector('[data-info-precio]');
  var antesEl = raiz.querySelector('[data-info-antes]');

  /* valor del equipo completo: barril + accesorios incluidos, a su precio por separado */
  var VALOR_EQUIPO = {
    '12-lb-charcoal-barrel-grill-roaster': 499.99,
    '28-lb-charcoal-barrel-grill-roaster': 589.99,
    '38-lb-charcoal-barrel-grill-roaster': 699.99
  };
  var tituloEl = raiz.querySelector('[data-info-titulo]');

  function numero(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isFinite(n) ? n : 0; }

  if (precios && precioEl && antesEl) {
    tarjeta = document.createElement('div');
    tarjeta.className = 'hb-precio';
    tarjeta.innerHTML =
      '<div class="hb-precio__cab">' + MEGAFONO + '<span data-p="cab1"></span><b data-p="cab2"></b></div>' +
      '<div class="hb-precio__cuerpo">' +
        '<div class="hb-precio__antes">' +
          '<span class="hb-precio__chip hb-precio__chip--gris" data-p="equipo"></span><s class="hb-precio__equipo" data-equipo></s>' +
          '<span class="hb-precio__chip hb-precio__chip--reg" data-p="reg"></span>' +
        '</div>' +
        '<div class="hb-precio__ahora"><span class="hb-precio__chip hb-precio__chip--oro" data-p="pre"></span></div>' +
      '</div>' +
      '<div class="hb-precio__reloj"><span class="hb-precio__reloj-tit"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 9v4l3 2M9 2h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span data-p="termina"></span></span>' +
        '<span class="hb-precio__cajas">' +
          '<span><b data-pr="d">00</b><i data-p="d"></i></span>' +
          '<span><b data-pr="h">00</b><i data-p="h"></i></span>' +
          '<span><b data-pr="m">00</b><i data-p="m"></i></span>' +
          '<span><b data-pr="s">00</b><i data-p="s"></i></span>' +
        '</span></div>' +
      '<div class="hb-precio__pie"><span><em data-p="ahorra"></em> <b data-ahorro-monto></b> <em data-p="ahora"></em></span><i aria-hidden="true"></i><span><b data-ahorro-pct></b> <em data-p="off"></em></span></div>';
    precios.parentNode.insertBefore(tarjeta, precios);
    tarjeta.querySelector('.hb-precio__antes').appendChild(antesEl);
    tarjeta.querySelector('.hb-precio__ahora').appendChild(precioEl);
    precios.classList.add('is-movido');

    var calcular = function () {
      var p = numero(precioEl.textContent), a = numero(antesEl.textContent);
      var hay = a > p && p > 0;
      tarjeta.classList.toggle('sin-ahorro', !hay);
      if (!hay) return;
      tarjeta.querySelector('[data-ahorro-monto]').textContent = '$' + (a - p).toFixed(2);
      tarjeta.querySelector('[data-ahorro-pct]').textContent = Math.round((a - p) / a * 100) + '%';
      var v = VALOR_EQUIPO[tituloEl && tituloEl.dataset.pdp];
      var hayEquipo = v && v > a;
      tarjeta.classList.toggle('sin-equipo', !hayEquipo);
      if (hayEquipo) tarjeta.querySelector('[data-equipo]').textContent = '$' + v.toFixed(2);
    };
    var textosPrecio = function () {
      Array.prototype.forEach.call(tarjeta.querySelectorAll('[data-p]'), function (el) {
        el.textContent = TP[idioma()][el.getAttribute('data-p')];
      });
    };
    new MutationObserver(calcular).observe(precioEl, { childList: true, characterData: true, subtree: true });
    new MutationObserver(calcular).observe(antesEl, { childList: true, characterData: true, subtree: true });
    if (tituloEl) new MutationObserver(calcular).observe(tituloEl, { attributes: true, attributeFilter: ['data-pdp'] });
    textosPrecio();
    calcular();
    reloj();
    document.addEventListener('humo:idioma', textosPrecio);
  }

  /* arranque: paso 1 abierto, paso 2 cerrado hasta que haya barril */
  poner(p2, false);
  leer();
})();
